import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import { useAppState } from "./hooks/useAppState";
import { useTheme } from "./hooks/useTheme";
import Header from "./components/Header";
import LoadingScreen from "./components/LoadingScreen";
import ChallengeView from "./components/ChallengeView";
import HistoryView from "./components/HistoryView";
import ProfileView from "./components/ProfileView";
import CommunityView from "./components/CommunityView";
import FeedbackView from "./components/FeedbackView";
import AdminFeedbackView from "./components/AdminFeedbackView";
import AdminSupportView from "./components/AdminSupportView";
import AdminUsersView from "./components/AdminUsersView";
import Footer from "./components/Footer";
import ErrorBoundary from "./components/ErrorBoundary";
import Onboarding from "./components/Onboarding";
import "./styles.css";

// The "1% Better Everyday" daily app. Mounted under /app/* by App.js, so all
// routes below are relative to /app.
export default function DailyApp() {
  const state = useAppState();
  const theme = useTheme();
  const catColor = state.selectedCat.color;
  const [showOnboarding, setShowOnboarding] = useState(() => {
    return !localStorage.getItem("onboarding_done");
  });

  if (state.authLoading) {
    return <LoadingScreen />;
  }

  // Chưa đăng nhập → hiện màn login fullscreen
  if (!state.session) {
    return (
      <div className="app-container">
        <ProfileView
          session={null}
          streak={{ current_streak: 0, longest_streak: 0 }}
          history={[]}
          onGoogleLogin={state.handleGoogleLogin}
          authError={state.authError}
          authSubmitting={state.authSubmitting}
        />
      </div>
    );
  }

  if (state.initLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="app-container">
      <Header
        catColor={catColor}
        streak={state.streak}
        session={state.session}
        theme={theme}
        onLogoClick={state.resetChallenge}
        notifications={state.notifications}
        setNotifications={state.setNotifications}
      />

      <div className="main-scroll">
      <div className="main-content" style={{ animation: "fadeIn 0.2s ease" }}>
        <ErrorBoundary>
        <Routes>
          <Route index element={
            <ChallengeView
              challenge={state.challenge}
              loading={state.loading}
              done={state.done}
              selectedCat={state.selectedCat}
              setSelectedCat={state.setSelectedCat}
              catColor={catColor}
              streak={state.streak}
              reflectionInput={state.reflectionInput}
              setReflectionInput={state.setReflectionInput}
              reflection={state.reflection}
              loadingReflect={state.loadingReflect}
              todayChallenges={state.todayChallenges}
              onGenerate={state.generateChallenge}
              onMarkDone={state.markDone}
              onGenerateReflection={state.generateReflection}
              onSaveReflection={state.saveReflection}
              onReset={state.resetChallenge}
            />
          } />
          <Route path="history" element={
            <HistoryView
              history={state.history}
              streak={state.streak}
              calMonth={state.calMonth}
              calYear={state.calYear}
              setCalMonth={state.setCalMonth}
              setCalYear={state.setCalYear}
              selectedDay={state.selectedDay}
              setSelectedDay={state.setSelectedDay}
              historyStyle={state.historyStyle}
              setHistoryStyle={state.setHistoryStyle}
            />
          } />
          <Route path="community" element={
            <CommunityView
              communityStats={state.communityStats}
              streak={state.streak}
              session={state.session}
            />
          } />
          <Route path="feedback" element={
            <FeedbackView />
          } />
          <Route path="admin" element={
            <AdminFeedbackView />
          } />
          <Route path="admin/support" element={
            <AdminSupportView />
          } />
          <Route path="admin/users" element={
            <AdminUsersView />
          } />
          <Route path="profile" element={
            <ProfileView
              session={state.session}
              streak={state.streak}
              history={state.history}
              onLogout={state.handleLogout}
            />
          } />
        </Routes>
        </ErrorBoundary>
      </div>
      </div>

      <Footer />

      {showOnboarding && (
        <Onboarding onComplete={() => {
          localStorage.setItem("onboarding_done", "1");
          setShowOnboarding(false);
        }} />
      )}
    </div>
  );
}
